module.exports = __webpack_public_path__ + "src/assets/models/environment/farm_scene.fbx";